import { ApiCaller } from '../../api-caller.service';
import { LoginAuthConnector } from './login.connector';
import { SignUpConnector } from './sign-up.connector';
import { TokenVaultsAuthConnector } from './token-vaults/token-vaults.connector';
import { UserRegistrationAuthConnector } from './user-registration';

export class AuthConnector {
  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  login = () => new LoginAuthConnector(this.apiCaller, this.prefix);
  signUp = () => new SignUpConnector(this.apiCaller, this.prefix);
  userRegistration = () => new UserRegistrationAuthConnector(this.apiCaller, this.prefix);
  tokenVaults = () => new TokenVaultsAuthConnector(this.apiCaller, this.prefix);
}
